export default "__VITE_ASSET__mbkwZOW9__"